<div class="atlas-form">
  <form #profileTypeForm="ngForm">
    <div class="mct-grid mct-cols-1-1 mct-gap-80"  >
      <div class="mct-flex mct-col mct-gap-27" *ngIf="hbaProfile"  >
        <div>
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.membership-type' | translate | ucfirst }}</label>
          <p-select
            name="memberTypeCode"
            [(ngModel)]="hbaProfile.MemberTypeCode"
            [placeholder]="'common.none' | translate | titlecase"
            [options]="membershipTypeItems"
            showClear
            styleClass="w-100"
          ></p-select>
        </div>
        <div>
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.membership-status' | translate | ucfirst }}</label>
          <p-select
            name="membershipStatusCode"
            [(ngModel)]="hbaProfile.MembershipStatusCode"
            [placeholder]="'common.none' | translate | titlecase"
            [options]="membershipStatusItems"
            showClear
            styleClass="w-100"
          ></p-select>
        </div>
        <div>
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.company-id' | translate }}</label>
          <input name="companyId" type="text" class="form-control" [(ngModel)]="hbaProfile.CompanyId" />
        </div>
        <div>
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.hba-number' | translate }}</label>
          <input name="hbaNumber" type="text" class="form-control" [(ngModel)]="hbaProfile.HBANumber" />
        </div>
        <div>
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.msn' | translate | uppercase }}</label>
          <input name="msn" type="text" class="form-control" [(ngModel)]="hbaProfile.SubscriptionId_MSN" />
        </div>
        <div>
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.pin' | translate | uppercase }}</label>
          <input name="pin" type="text" class="form-control" [(ngModel)]="hbaProfile.ContactPersonId_PIN" />
        </div>
      </div>
      <div class="mct-flex mct-col mct-gap-27" *ngIf="hbaProfile"  >
        <div>
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.primary-business-activity' | translate | ucfirst
            }}</label>
          <p-select name="primaryBusinessActivity" [(ngModel)]="hbaProfile.PrimaryBusActivityCode"
            [placeholder]="'common.none' | translate | titlecase" [options]="businessActivityItems" showClear styleClass="w-100" (onChange)="handlePrimaryBusinessActivity($event.value)">
          </p-select>
        </div>
        <div *ngIf="showCustomPrimaryBusinessActivity">
          <label for="customPrimaryBusinessActivity" class="light-text">{{ 'profiles.edit.profile-type.nahb.custom-primary-business-activity' | translate | ucfirst }}</label>
          <input name="customPrimaryBusinessActivity" type="text" class="form-control" [(ngModel)]="hbaProfile.CustomPrimaryBusActivity" />
        </div>
        <div>
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.secondary-business-activity' | translate | ucfirst
            }}</label>
          <p-select name="secondaryBusinessActivity" [(ngModel)]="hbaProfile.SecondaryBusActivityCode"
            [placeholder]="'common.none' | translate | titlecase" [options]="businessActivityItems" showClear styleClass="w-100">
          </p-select>
        </div>
        <div>
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.tertiary-business-activity' | translate | ucfirst
            }}</label>
          <p-select name="tertiaryBusinessActivity" [(ngModel)]="hbaProfile.TertiaryBusActivityCode"
            [placeholder]="'common.none' | translate | titlecase" [options]="businessActivityItems" showClear styleClass="w-100">
          </p-select>
        </div>
        <div>
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.number-of-units' | translate | ucfirst }}</label>
          <p-select name="numberOfUnitsCode" [(ngModel)]="hbaProfile.NumberOfUnitsCode"
            [placeholder]="'common.none' | translate | titlecase" [options]="numberOfUnitsItems" showClear styleClass="w-100">
          </p-select>
        </div>
        <div>
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.dollar-volume' | translate | ucfirst }}</label>
          <p-select name="dollarVolumeCode" [(ngModel)]="hbaProfile.DollarVolumeCode"
            [placeholder]="'common.none' | translate | titlecase" [options]="dollarVolumeItems" showClear styleClass="w-100"></p-select>
        </div>
        <div [hidden]="hbaProfile.OrgInd">
          <label class="light-text">{{ 'profiles.edit.profile-type.nahb.contact-title' | translate | ucfirst }}</label>
          <p-select name="contactTitle" [(ngModel)]="hbaProfile.ContactTitleCode"
           [placeholder]="'common.none' | translate | titlecase" [options]="contactTitleItems" showClear styleClass="w-100"></p-select>
        </div>
      </div>
    </div>
  </form>
</div>
